import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { UmmsOverviewParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';

import { useUmm } from 'src/apis/iip-service/use-umm';
import { useUmms } from 'src/apis/iip-service/use-umms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useUmmsPageParams } from 'src/pages/market-messages/urgent-market-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const UrgentMarketMessageEdit: FC<Props> = ({ iipService }) => {
  const params = useUmmsPageParams();
  const transformedParams = useMemo(() => {
    const { start, pageSize } = params.value;
    return {
      offset: start,
      limit: pageSize,
    } satisfies UmmsOverviewParams;
  }, [params.value]);

  const ummsRequest = useUmms({ iipService, params: transformedParams });
  const ummRequest = useUmm({ ummsRequest });

  if (!ummRequest.response) return <PageSpinner />;

  return <Page ummRequest={ummRequest} />;
};
